@if (currentElement) {
  <div class="drawer-body">

    <div class="flex align-item-center ">

      <div class="flex-shrink-0 m-r-10">
        <img
          [src]="'images/vehicles/' + ((mobile)?.icon || 'default') + '.png' | asset : 'bucket'"
          alt="user-image"
          class="user-avtar wid-50 hie-50 b-rad-10" />
      </div>

      <div class="flex-grow-1 p-2">
        <div class="f-w-500">
          @if ((sensors | findOfArray : { key: 'ignition' })?.enable) {
            <div>
              @if ((position)?.sensors?.['ignition']) {
                <div class="text-success-500">
                  <i class="fa-solid fa-power-off"></i>
                  Motor Encendido
                </div>
              } @else {
                <div class="text-accent-500 ">
                  <i class="fa-solid fa-power-off"></i>
                  Motor Apagado
                </div>
              }
            </div>
          }

          @if ((position)?.speed > 2) {
            <div class="text-primary-500 ">
              <i class="fi fi-br-tachometer-fast text-primary-500"></i>
              En movimiento a {{ ((position)?.speed)  | renderSpeed }}
            </div>
          } @else {
            <div class=" text-warn-500 ">
              <i class="fi fi-br-tachometer-slowest"></i>
              Estacionado
            </div>
          }

          @if (!(position)?.deviceTime) {
            <div class="text-warning-500">
              <i class="fi fi-rr-wifi-slash fa-beat" title="Desconectado"></i>
              Nunca ha reportado
            </div>
          } @else if (((position)?.deviceTime | isDisconnect)) {
            <div class="text-warning-500">
              <i class="fi fi-br-wifi-slash fa-beat" title="Desconectado"></i>
              Desconetado hace
              <app-duration-text [dateValue]="(position)?.deviceTime" />
            </div>
          } @else {
            <div>
              <i class="fi fi-br-wifi" title="Conectado"></i>
              Reporto hace
              <app-duration-text [dateValue]="(position)?.deviceTime" />
            </div>
          }
        </div>
      </div>
    </div>
    <br/>

    <div class="row text-center">
      <div class="col-4 col-lg-4 col-xxl-4">
        <button mat-flat-button color="primary" (click)="sendCommand()">
          <i class="fi fi-br-paper-plane"></i>
        </button>
      </div>

      <div class="col-4 col-lg-4 col-xxl-4" [matMenuTriggerFor]="menuResume">
        <button mat-flat-button color="accent">
          <i class="fa-solid fa-chart-gantt"></i>
        </button>

        <mat-menu #menuResume="matMenu">
          <button mat-menu-item (click)="showPosition()">
            <span>
              Informacion de posicion
            </span>
          </button>
          <button mat-menu-item (click)="toTravelToday()">
              <span>
                Recorrido de hoy
              </span>
          </button>
          <button mat-menu-item (click)="toActivityToday()">
              <span>
                Actividade de hoy
              </span>
          </button>
          <button mat-menu-item (click)="toActivityToday()">
              <span>
                Resumen de hoy
              </span>
          </button>
        </mat-menu>
      </div>

      <div class="col-4 col-lg-4 col-xxl-4"  [matMenuTriggerFor]="menuConfig">
        <button mat-flat-button color="warn">
          <i class="fa-solid fa-sliders"></i>
        </button>
        <mat-menu #menuConfig="matMenu">
          @if (currentElement?.mobile) {
            <a [routerLink]="['/','console', 'mobiles', currentElement.mobile?._id,'edit']" mat-menu-item >
              <span>
                Configurar vehiculo
              </span>
            </a>
            <a [routerLink]="['/','console', 'mobiles', currentElement.mobile?._id,'alarms']" mat-menu-item >
              <span>
                Configurar alarmas
              </span>
            </a>
          }
        </mat-menu>
      </div>
    </div>
    <br/>

    <app-command-resume-view [command]="currentElement?.command"/>
    <br/>

    <app-detail-current-day-mobile [currentMobileId]="currentElement?._id" />
    <app-speedometer [value]="((position)?.speed || 0)" />

    <br />
    <mat-divider />
    <br />
    <br />

    @if (position) {
      <app-card class="list-group-item my-task" [showHeader]="false" padding="5">
        <div class="flex align-item-center p-2">
          <div class="flex-grow-1 m-l-10">
            <span class="f-w-600">Ubicacion </span><!--<span class="task-time ">{{attr.type}}</span>-->
            <p class="m-b-5">
            </p>

            <div class="d-flex justify-content-between">
              <div class="d-flex align-items-center">
                <a
                  [href]="'https://www.google.com/maps?q='+ position?.geometric?.coordinates[1] + ',' + position?.geometric?.coordinates[0]"
                  class="text-primary-500"
                  target="_blank">
                  <code>
                    {{ position?.geometric?.coordinates[1]?.toFixed(7) }},
                    {{ position?.geometric?.coordinates[0]?.toFixed(7) }}
                  </code>
                </a>
              </div>
            </div>
          </div>

        </div>
      </app-card>
    }

    <br />

    <app-card [cardTitle]="'Informacion del dispositivo'" padding="10">
      <div class="flex align-item-center p-2">
        <div class="flex-grow-1 m-l-10">
          <span class="f-w-600">Identificador unico </span><!--<span class="task-time ">{{attr.type}}</span>-->
          <p class="m-b-5">
          </p>

          <div class="d-flex justify-content-between">
            <div class="d-flex align-items-center">
              {{ device?.uniqueId }}
            </div>
          </div>
        </div>

      </div>

      <hr/>
      <div class="flex align-item-center p-2">
        <div class="flex-grow-1 m-l-10">
          <span class="f-w-600">Estado en el escuchador </span><!--<span class="task-time ">{{attr.type}}</span>-->
          <p class="m-b-5">
          </p>

          <div class="d-flex justify-content-between">
            <div class="d-flex align-items-center">
              {{ device?.status }}
            </div>
          </div>
        </div>

      </div>

      <hr/>
      <div class="flex align-item-center p-2">
        <div class="flex-grow-1 m-l-10">
          <span class="f-w-600">Hardware</span><!--<span class="task-time ">{{attr.type}}</span>-->
          <p class="m-b-5">
          </p>

          <div class="d-flex justify-content-between">
            <div class="d-flex align-items-center">
              {{ currentElement?.hardware?.name || 'No definido' }}
            </div>
          </div>
        </div>

      </div>

      <hr/>
      <div class="flex align-item-center p-2">
        <div class="flex-grow-1 m-l-10">
          <span class="f-w-600">Numero de simcard</span><!--<span class="task-time ">{{attr.type}}</span>-->
          <p class="m-b-5">
          </p>

          <div class="d-flex justify-content-between">
            <div class="d-flex align-items-center">
              {{ currentElement?.simCard?.phoneLine || 'No definido' }}
            </div>
          </div>
        </div>

      </div>

      <hr/>
      <div class="flex align-item-center p-2">
        <div class="flex-grow-1 m-l-10">
          <span class="f-w-600">Identificador de simcard</span><!--<span class="task-time ">{{attr.type}}</span>-->
          <p class="m-b-5">
          </p>

          <div class="d-flex justify-content-between">
            <div class="d-flex align-items-center">
              {{ currentElement?.simCard?.cardUniqueId || 'No definido' }}
            </div>
          </div>
        </div>
      </div>

      <hr/>
      <div class="flex align-item-center p-2">
        <div class="flex-grow-1 m-l-10">
          <span class="f-w-600">Escuchador</span><!--<span class="task-time ">{{attr.type}}</span>-->
          <p class="m-b-5">
          </p>

          <div class="d-flex justify-content-between">
            <div class="d-flex align-items-center">
              {{ currentElement?.device?.listenerIp || 'No definido' }} ({{ currentElement?.device?.listenerName }})
            </div>
          </div>
        </div>
      </div>

      <hr/>
      <div class="flex align-item-center p-2">
        <div class="flex-grow-1 m-l-10">
          <span class="f-w-600">Id Externo</span><!--<span class="task-time ">{{attr.type}}</span>-->
          <p class="m-b-5">
          </p>

          <div class="d-flex justify-content-between">
            <div class="d-flex align-items-center">
              {{ currentElement?.device?.externalId || 'No definido' }}
            </div>
          </div>
        </div>
      </div>

      <hr/>
      <div class="flex align-item-center p-2">
        <div class="flex-grow-1 m-l-10">
          <span class="f-w-600">Propietario</span><!--<span class="task-time ">{{attr.type}}</span>-->
          <p class="m-b-5">
          </p>

          <div class="d-flex justify-content-between">
            <div class="d-flex align-items-center">
              {{ currentElement?.property?.name || 'No definido' }}
            </div>
          </div>
        </div>
      </div>

    </app-card>
  </div>

}
